import React, { useState, useRef, useEffect } from "react";
import { api } from "../api";

export default function Login({ onLogin, onForgotPassword }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token, user } = await api.login(username.trim(), password);
      onLogin(token, user); // smonta questo componente
    } catch (err) {
      if (mountedRef.current) {
        setError(err.message);
        setLoading(false);
      }
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">

        {/* Logo / intestazione istituzionale */}
        <div className="login-logo">
          <svg viewBox="0 0 64 64" width="60" height="60" fill="none">
            <circle cx="32" cy="32" r="32" fill="#1a5276"/>
            {/* croce medica */}
            <rect x="26" y="14" width="12" height="36" rx="3" fill="#fff"/>
            <rect x="14" y="26" width="36" height="12" rx="3" fill="#fff"/>
            {/* cuore piccolo al centro */}
            <path d="M32 36 c0 0-6-4-6-8 a4 4 0 0 1 6-3.46 A4 4 0 0 1 38 28 c0 4-6 8-6 8z" fill="#1a5276"/>
          </svg>
        </div>

        <div className="login-institution">
          <span className="login-dept">Dipartimento di Oncologia Sperimentale</span>
          <h1>Larkhill Research Portal</h1>
          <p className="login-subtitle">
            Piattaforma riservata ai ricercatori autorizzati.<br/>
            L'accesso non autorizzato è perseguibile ai sensi del D.Lgs. 231/2001.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <label>
            <span>ID Ricercatore</span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value.toLowerCase())}
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              placeholder="es. m.rossi"
              autoFocus
              required
            />
          </label>
          <label>
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="••••••••"
              required
            />
          </label>

          {error && <p className="login-error">⚠ Credenziali non riconosciute. Contattare l'amministratore di sistema.</p>}

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Verifica in corso…" : "Accedi al portale"}
          </button>
        </form>

        <button className="login-link" onClick={onForgotPassword}>Password dimenticata?</button>

        <p className="login-footer">
          Larkhill v2.4 &nbsp;·&nbsp; © 2025 Centro di Ricerca Clinica<br/>
          <small>Sessione cifrata TLS 1.3 &nbsp;🔒</small>
        </p>

      </div>
    </div>
  );
}
